import React from 'react';
import { useGame } from '../context/GameContext.jsx';

const BottomBar = () => {
  const {
    translations,
    lang,
    returnToInitialScreen,
    navigateToMissionScreen,
    navigateToScanScreen,
    navigateToLastScannedCardScreen,
    navigateToSendScreen,
    lastScannedCardCode,
    gameStatus
  } = useGame();

  const getButtonClass = (screen) => {
    return `bottom-bar-button ${gameStatus === screen ? 'active' : ''}`;
  };

  return (
    <div className="bottom-bar">
      <div className="bottom-bar-item">
        <button className={getButtonClass('initial')} onClick={returnToInitialScreen} title={translations[lang]?.home_button_label}>
          <i className="fas fa-home bottom-bar-icon"></i>
        </button>
      </div>

      <div className="bottom-bar-item">
        <button className={getButtonClass('mission')} onClick={navigateToMissionScreen} title={translations[lang]?.mission_button_label}>
          <i className="fa-regular fa-rectangle-list bottom-bar-icon"></i>
        </button>
      </div>

      <div className="qr-scan-button-container">
        <button className="qr-scan-button" onClick={navigateToScanScreen} title={translations[lang]?.scan_qr_button}>
          <i className="fas fa-qrcode qr-scan-icon"></i>
        </button>
      </div>

      <div className="bottom-bar-item">
        <button
          className={getButtonClass('lastScanned')}
          onClick={navigateToLastScannedCardScreen}
          title={translations[lang]?.last_scanned_card_button_label}
          disabled={!lastScannedCardCode}
        >
          <i className="fa-regular fa-file bottom-bar-icon"></i>
        </button>
      </div>

      <div className="bottom-bar-item">
        <button className={getButtonClass('send')} onClick={navigateToSendScreen} title={translations[lang]?.solve_button}>
          <i className="fas fa-paper-plane bottom-bar-icon"></i>
        </button>
      </div>
    </div>
  );
};

export default BottomBar;
